module.exports = __webpack_public_path__ + "img/head.21d2dac4.png";